import type * as CalloutBox from '../types/CalloutBox'
import { imageParser } from '../props/parsers/Image'

export default function calloutBoxComponentParser(
  rawComponent: CalloutBox.Raw,
): CalloutBox.Parsed {
  const { image, ...rest } = rawComponent.calloutBox

  return {
    name: 'CalloutBox',
    props: {
      ...rest,
      ...imageParser(image),
    },
  }
}
